/** What the host page knows about its visitor, and its HMAC, as the client sends it. */

// Mirrors the backend cap (api/v1/brain_webchat/schemas.py) only so an oversized
// bag is dropped with a warning instead of 422-ing every open. Compact JSON +
// UTF-8 bytes match the server's ensure_ascii=False measure.
const MAX_EMBED_PARAMS_BYTES = 8 * 1024;
const MAX_EMBED_PARAMS_KEYS = 50;

/** HMAC the host computes on its server over the identifying params. */
export interface WidgetVerification {
  signature: string;
  issuedAt: number;
}

function withinEmbedParamsCaps(params: Record<string, unknown>): boolean {
  if (Object.keys(params).length > MAX_EMBED_PARAMS_KEYS) return false;
  return new TextEncoder().encode(JSON.stringify(params)).length <= MAX_EMBED_PARAMS_BYTES;
}

/** Drop an oversized bag (with a warning) rather than let it 422 the chat. */
export function capEmbedParams(
  params?: Record<string, unknown>,
): Record<string, unknown> | undefined {
  if (!params || withinEmbedParamsCaps(params)) return params;
  console.warn(
    `KapiaWidget: params dropped — exceeds ${MAX_EMBED_PARAMS_KEYS} keys or ${MAX_EMBED_PARAMS_BYTES} bytes`,
  );
  return undefined;
}

/** Server shape of the signature envelope, or null when unset. */
export function verificationBody(
  verification?: WidgetVerification,
): { signature: string; issued_at: number } | null {
  if (!verification) return null;
  return { signature: verification.signature, issued_at: verification.issuedAt };
}
